<template>
  <div />
</template>

<script>
import Vue from "vue";

export default {
  name: "BasePage",
  data() {
    return {
      initiated: false
    };
  },

  methods: {
    init: function() {},

    routeEnter: function() {}
  },

  beforeRouteEnter(to, from, next) {
    next(async function(vm) {
      await vm.$global.pageInitiated;

      if (vm.initiated === false) {
        await vm.init();
        vm.initiated = true;
      }
      if (vm.initiated === true) await vm.routeEnter(to, from);
      await Vue.nextTick();
    });
  }
};
</script>

<style lang="scss" scoped></style>
